import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Retransmit = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Retransmit({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.2959 11.8679C9.49116 11.6726 9.80767 11.6726 10.0029 11.8679L14.0684 15.9333C14.2636 16.1286 14.2636 16.4451 14.0684 16.6403L10.0029 20.7067C9.8078 20.9018 9.49118 20.9016 9.2959 20.7067L8.94238 20.3532C8.74712 20.158 8.74712 19.8405 8.94238 19.6452L11.5508 17.0368H3.96191C3.68577 17.0368 3.46191 16.813 3.46191 16.5368V16.0368C3.46196 15.7607 3.6858 15.5368 3.96191 15.5368H11.5508L8.94238 12.9284C8.74712 12.7332 8.74712 12.4167 8.94238 12.2214L9.2959 11.8679ZM13.9971 3.29463C14.1923 3.09938 14.5088 3.09938 14.7041 3.29463L15.0576 3.64815C15.2529 3.84341 15.2529 4.15992 15.0576 4.35518L12.4492 6.96358H20.0381C20.3142 6.96358 20.538 7.18747 20.5381 7.46358V7.96358C20.5381 8.23972 20.3142 8.46358 20.0381 8.46358H12.4492L15.0576 11.072C15.2529 11.2672 15.2529 11.5847 15.0576 11.78L14.7041 12.1335C14.5088 12.3283 14.1922 12.3286 13.9971 12.1335L9.93164 8.0671C9.73639 7.87183 9.73638 7.55532 9.93164 7.36006L13.9971 3.29463Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'retransmit-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Retransmit;
